import { render, staticRenderFns } from "./ERPSummary.vue?vue&type=template&id=929a80e4&"
import script from "./ERPSummary.vue?vue&type=script&lang=js&"
export * from "./ERPSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports